export const constructDuodate = (
    days: number,
    hours: number,
    minutes: number
) => {
    const minutesInDays = days * 60 * 24;
    const minutesInHours = hours * 60;
    const dueDate = minutesInDays + minutesInHours + minutes;
    return dueDate;
};

export const destructDuoDate = (dueDate: number) => {
    // const minutesInHour = 60;
    const mintuesInDay = 60 * 24;
    const days = Math.floor(dueDate / mintuesInDay);
    const remiander = dueDate % mintuesInDay;
    const hours = Math.floor(remiander / 60);
    const minutes = remiander % 60;
    return { days, hours, minutes };
};
